"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emergencyContactRemovedPayloadSchema = exports.guardianRemovedPayloadSchema = exports.protectionRemovedPayloadSchema = exports.mergeRolledBackPayloadSchema = exports.mergeStartedPayloadSchema = exports.consentWithdrawnPayloadSchema = exports.coverageUpdatedPayloadSchema = exports.emergencyContactAddedPayloadSchema = exports.guardianAddedPayloadSchema = exports.documentVerifiedPayloadSchema = exports.identityResolvedPayloadSchema = exports.protectionAppliedPayloadSchema = exports.mergeCompletedPayloadSchema = exports.consentGrantedPayloadSchema = exports.coverageAddedPayloadSchema = exports.patientUpdatedPayloadSchema = exports.patientRegisteredPayloadSchema = exports.PatientEventNames = void 0;
/**
 * Domain event names + payload schemas for the Patient Identity
 * bounded context. The original 10 (Stage 4C.2) are the raw shapes
 * Domain Services publish directly through `core/eventbus`. Stage
 * 4C.3 adds 7 more (`COVERAGE_UPDATED`, `CONSENT_WITHDRAWN`,
 * `MERGE_STARTED`, `MERGE_ROLLED_BACK`, `PROTECTION_REMOVED`,
 * `GUARDIAN_REMOVED`, `EMERGENCY_CONTACT_REMOVED`) for the Application
 * Layer's richer, enveloped Domain Event Layer
 * (`modules/patient/_shared-event`) — published by Application
 * Services, validated against Patient Identity's own event registry,
 * not `core/eventbus`'s catalog. See
 * docs/PATIENT-APPLICATION-ARCHITECTURE.md for why the two mechanisms
 * coexist rather than merge.
 */
const zod_1 = require("zod");
exports.PatientEventNames = {
    PATIENT_REGISTERED: 'patient.registered',
    PATIENT_UPDATED: 'patient.updated',
    COVERAGE_ADDED: 'patient.coverage-added',
    COVERAGE_UPDATED: 'patient.coverage-updated',
    CONSENT_GRANTED: 'patient.consent-granted',
    CONSENT_WITHDRAWN: 'patient.consent-withdrawn',
    MERGE_STARTED: 'patient.merge-started',
    MERGE_COMPLETED: 'patient.merge-completed',
    MERGE_ROLLED_BACK: 'patient.merge-rolled-back',
    PROTECTION_APPLIED: 'patient.protection-applied',
    PROTECTION_REMOVED: 'patient.protection-removed',
    IDENTITY_RESOLVED: 'patient.identity-resolved',
    DOCUMENT_VERIFIED: 'patient.document-verified',
    GUARDIAN_ADDED: 'patient.guardian-added',
    GUARDIAN_REMOVED: 'patient.guardian-removed',
    EMERGENCY_CONTACT_ADDED: 'patient.emergency-contact-added',
    EMERGENCY_CONTACT_REMOVED: 'patient.emergency-contact-removed',
};
exports.patientRegisteredPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid(),
    uhid: zod_1.z.string(),
    registrationChannel: zod_1.z.string(),
    isUnknownIdentity: zod_1.z.boolean(),
});
exports.patientUpdatedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid(),
    changedFields: zod_1.z.array(zod_1.z.string()),
});
exports.coverageAddedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid(),
    coverageId: zod_1.z.string().uuid(),
    payerId: zod_1.z.string().uuid(),
});
exports.consentGrantedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid(),
    consentId: zod_1.z.string().uuid(),
    consentType: zod_1.z.string(),
});
exports.mergeCompletedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    mergeId: zod_1.z.string().uuid(),
    sourcePatientId: zod_1.z.string().uuid(),
    targetPatientId: zod_1.z.string().uuid(),
});
exports.protectionAppliedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    protectionId: zod_1.z.string().uuid(),
    protectedEntityType: zod_1.z.string(),
    protectedEntityId: zod_1.z.string().uuid(),
    protectionCategory: zod_1.z.string(),
});
exports.identityResolvedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    candidateId: zod_1.z.string().uuid(),
    patientAId: zod_1.z.string().uuid(),
    patientBId: zod_1.z.string().uuid(),
    outcome: zod_1.z.enum(['MERGE_RECOMMENDED', 'REJECTED']),
});
exports.documentVerifiedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    documentId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid(),
    verificationSource: zod_1.z.string(),
});
exports.guardianAddedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    guardianId: zod_1.z.string().uuid(),
    wardPatientId: zod_1.z.string().uuid(),
});
exports.emergencyContactAddedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    emergencyContactId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid(),
});
exports.coverageUpdatedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid(),
    coverageId: zod_1.z.string().uuid(),
    changeType: zod_1.z.enum(['UPDATED', 'VERIFIED', 'EXPIRED']),
});
exports.consentWithdrawnPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid(),
    consentId: zod_1.z.string().uuid(),
    consentType: zod_1.z.string(),
});
exports.mergeStartedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    mergeId: zod_1.z.string().uuid(),
    sourcePatientId: zod_1.z.string().uuid(),
    targetPatientId: zod_1.z.string().uuid(),
});
exports.mergeRolledBackPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    unmergeId: zod_1.z.string().uuid(),
    originalMergeId: zod_1.z.string().uuid(),
    sourcePatientId: zod_1.z.string().uuid(),
    targetPatientId: zod_1.z.string().uuid(),
});
exports.protectionRemovedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    protectionId: zod_1.z.string().uuid(),
    protectedEntityType: zod_1.z.string(),
    protectedEntityId: zod_1.z.string().uuid(),
    reason: zod_1.z.enum(['RELEASED', 'REJECTED']),
});
exports.guardianRemovedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    guardianId: zod_1.z.string().uuid(),
    wardPatientId: zod_1.z.string().uuid(),
});
exports.emergencyContactRemovedPayloadSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    emergencyContactId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid(),
});
//# sourceMappingURL=patient.events.js.map